import type { DailyShiftSlotRepository } from './ports/DailyShiftSlotRepository';

export interface SendUrgentNotificationInput {
  year: number;
  month: number;
  doctorIds: string[];
}

export interface SendUrgentNotificationOutput {
  success: boolean;
  errors?: string[];
}

/**
 * 急募枠通知を送信するUseCase
 * @param repository DailyShiftSlotRepository リポジトリインスタンス
 * @param input SendUrgentNotificationInput 通知データ
 * @returns Promise<SendUrgentNotificationOutput> 送信結果
 */
export async function sendUrgentNotification(
  repository: DailyShiftSlotRepository,
  input: SendUrgentNotificationInput
): Promise<SendUrgentNotificationOutput> {
  try {
    await repository.sendUrgentNotification({
      year: input.year,
      month: input.month,
      doctorIds: input.doctorIds,
    });
    return { success: true };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : '急募通知送信に失敗しました';
    return { success: false, errors: [errorMessage] };
  }
}
